import { useState } from 'react'
import { Press } from '@dorixona/ui'
import { isoDay, nowMs } from '@dorixona/utils'
import { Icon } from './Icon'
import { failureText } from './Load'

/**
 * Сохранить файл, пришедший из API, как будто его скачали по ссылке: ссылку
 * на файл нельзя открыть напрямую — запросу нужен токен в заголовке.
 */
export function saveFile(file: Blob, name: string): void {
  const url = URL.createObjectURL(file)
  const link = document.createElement('a')
  link.href = url
  link.download = name
  document.body.append(link)
  link.click()
  link.remove()
  // Браузер забирает файл по ссылке асинхронно — отпускаем её следующим тиком.
  setTimeout(() => {
    URL.revokeObjectURL(url)
  }, 0)
}

/** Имя выгрузки с датой: «zakazy-2026-10-01.xlsx» — файлы за разные дни не путаются. */
export function fileName(prefix: string, now: number = nowMs()): string {
  return `${prefix}-${isoDay(now)}.xlsx`
}

export interface ExportButtonProps {
  /** Имя файла без даты: «zakazy» → «zakazy-2026-10-01.xlsx». */
  prefix: string
  /** Запрос выгрузки с теми же фильтрами, что у таблицы. */
  load: () => Promise<Blob>
  /** Выгрузка не прошла — что сказать в углу. */
  onError: (message: string) => void
}

/**
 * «Выгрузить в Excel» в строке заголовка раздела: выгружает то, что сейчас
 * отфильтровано, а не всю базу. Пока файл готовится, кнопка занята.
 */
export function ExportButton({ prefix, load, onError }: ExportButtonProps) {
  const [busy, setBusy] = useState(false)
  return (
    <Press
      as="button"
      type="button"
      className="ui-btn"
      data-variant="secondary"
      squish="card"
      disabled={busy}
      aria-busy={busy}
      onPress={() => {
        setBusy(true)
        load()
          .then(
            (file) => {
              saveFile(file, fileName(prefix))
            },
            (error: unknown) => {
              onError(failureText(error))
            },
          )
          .finally(() => {
            setBusy(false)
          })
      }}
    >
      <Icon name="i-down" />
      Выгрузить в Excel
    </Press>
  )
}
